<template>

    <div class="boolean_icon">

        <i v-if="isTrue" class="right_icon zmdi zmdi-check"></i>
        <i v-else class="bad_icon zmdi zmdi-close"></i>
    </div>

</template>


<script>
export default {
    name: 'BooleanIcon',
    props: {
        isTrue: {
            type: Boolean,
            required: true
        }
    }
}
</script>

<style lang="scss">
.boolean_icon{
    font-size: 2rem;
    display: inline-block;
    .right_icon{
        color: $success;
    }
    .bad_icon{
        color: $danger;
    }
}
</style>